<template>
  <transition name="scale-transition" appear :class="customClasses">
    <slot></slot>
  </transition>
</template>
<script>
export default {
  name: 'ScaleTransition',
  props: {
    customClasses: String
  }
};
</script>

<style lang="scss">
@import '~@/scss/components/transitions/scale_transition.scss';
</style>
